/* loaded by smart-asset */
export default require("./layers_clear-24px~EKopPpvI.svg")